import styled from 'styled-components';

export const EmptyView = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 65px;
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #ADB5BD;
`;